import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import CardList from './components/CardList';
import Filters from './components/Filters';
import CardModal from './components/CardModal';
import Pagination from './components/Pagination';
import Categories from './components/Categories';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import ActiveFilters from './components/ActiveFilters';
import axios from 'axios';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import SettingsModal from './components/SettingsModal';
import SupportWebsiteModal from './components/SupportWebsiteModal';
import UserProfile from './components/UserProfile';
import { useUser } from './UserContext'; // Import the useUser hook
import './main.css';
import { Navbar, Nav, Form, FormControl, Button, NavDropdown, Container, Offcanvas } from 'react-bootstrap'; // Import Bootstrap components
import { FaBars, FaBell } from 'react-icons/fa';
import { useSwipeable } from 'react-swipeable';
import NotificationsPage from './components/NotificationsPage'; // Import the NotificationsPage component
import { Outlet, Link } from "react-router-dom";
import { buildUrlWithParams } from './components/utils.js'
import CustomScrollRestoration from './components/CustomScrollRestoration';

import LoginForm from './components/LoginForm';
import RegisterForm from './components/RegisterForm';
//import './mobile.css';
import { FaDiaspora, FaBug, FaShieldAlt } from "react-icons/fa";
import { IoMdChatboxes, IoIosRibbon } from "react-icons/io";
import { FaNewspaper, FaLightbulb } from "react-icons/fa6";
import { ModeratorActionProvider } from './ModeratorActionContext';
import ContestButton from './components/ContestButton';

function getCookie(cookieName) {
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === cookieName) {
      return decodeURIComponent(value);
    }
  }
  return null;
}


function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const [searchParams, setSearchParams] = useSearchParams();
  const [cards, setCards] = useState([]);
  const [selectedCard, setSelectedCard] = useState(params.get('selectedCard') || null);
  const [currentPage, setCurrentPage] = useState(parseInt(params.get('page'), 10) || 1);
  const [totalPages, setTotalPages] = useState(1);

  const [unreadNotifications, setUnreadNotifications] = useState(0);




  // const [filters, setFilters] = useState({
  //   class: params.get('class') || '',
  //   cost: params.get('cost') || '',
  //   category: params.get('category') || '',
  //   cardtype: params.get('cardtype') || '',
  //   search: params.get('search') || '',
  //   startDate: params.get('startDate') || '',
  //   endDate: params.get('endDate') || '',
  // });
  const { user, setUser, filters, setFilters } = useUser();


  useEffect(() => {
    const fetchNotifications = async () => {
      if (user) {
        try {
          const response = await axios.get('/api/users/notifications_time.php');
          const unreadCount = response.data.notifications.filter(n => !n.is_read).length;
          setUnreadNotifications(unreadCount);
        } catch (error) {
          console.error('Error fetching notifications:', error);
        }
      }
    };

    fetchNotifications();
    // Set up an interval to check for new notifications every 20 seconds
    const intervalId = setInterval(fetchNotifications, 20 * 1000);

    // Clean up the interval on component unmount
    return () => clearInterval(intervalId);
  }, [user]);


  useEffect(() => {
    //console.log(params.get('selectedCard'));
    setSelectedCard(params.get('selectedCard') || null);
  }, [params.get('selectedCard')]);

  // useEffect(() => {
  //   const params = new URLSearchParams();
  //   Object.entries(filters).forEach(([key, value]) => {
  //     if (value) {
  //       params.set(key, value);
  //     }
  //   });
  //   if (currentPage > 1) {
  //     params.set('page', currentPage);
  //   }
  //   if (selectedCard) {
  //     params.set('selectedCard', selectedCard);
  //   } else {
  //     params.delete('selectedCard');
  //   }

  //   navigate({ search: params.toString() }, { replace: true });
  // }, [selectedCard]);


  const [settings, setSettings] = useState({
    cardsPerRow: localStorage.getItem('cardsPerRow') || 2,
    language: getCookie('language_creator') || 'en',
  });



  const [showSettings, setShowSettings] = useState(false);
  const [showSupportWebsite, setShowSupportWebsite] = useState(false);

  const [isLoading, setIsLoading] = useState(0);

  const [showLoginForm, setShowLoginForm] = useState(false);

  const [showSidebar, setShowSidebar] = useState(false);



  //
  const [showNotifications, setShowNotifications] = useState(false);
  const handleNotificationsClick = () => {
    setShowNotifications(true);
  };

  const handleCloseNotifications = () => {
    setShowNotifications(false);
  };

  const handleToggleSidebar = () => setShowSidebar(!showSidebar);

  // const swipeHandlers = useSwipeable({
  //   onSwiped: (eventData) => {
  //     if (selectedCard) return; // Don't perform any action if a card is selected

  //     const screenWidth = window.innerWidth;
  //     const swipeDistance = Math.abs(eventData.deltaX);
  //     const swipeThreshold = screenWidth * 0.3; // 50% of screen width

  //     if (swipeDistance >= swipeThreshold) {
  //       if (eventData.dir === 'Right') {
  //         setShowSidebar(true);
  //       } else if (eventData.dir === 'Left') {
  //         setShowSidebar(false);
  //       }
  //     }
  //   },
  //   trackMouse: true,
  //   preventDefaultTouchmoveEvent: true,
  // });

  const swipeHandlers = useSwipeable({
    onSwiped: (eventData) => {
      const screenWidth = window.innerWidth;
      const swipeDistance = Math.abs(eventData.deltaX);
      const swipeThreshold = screenWidth * 0.3;

      if (selectedCard) {
        const currentCardIndex = cards.findIndex(card => card.id === selectedCard);
        const cardModal = document.querySelector('.card-modal');
        if (swipeDistance >= swipeThreshold) {
          if (eventData.dir === 'Right') {
            if (currentCardIndex > 0) {
              // Previous card
              const newSelectedCard = cards[currentCardIndex - 1].id;
              setSelectedCard(newSelectedCard);
              params.set('selectedCard', newSelectedCard);
              if (cardModal) {
                cardModal.scrollTo({ top: 0, behavior: 'smooth' });
              }
            } else if (currentPage > 1) {
              params.set('page', currentPage - 1);
            }
          } else if (eventData.dir === 'Left') {
            if (currentCardIndex < cards.length - 1) {
              // Next card
              const newSelectedCard = cards[currentCardIndex + 1].id;
              setSelectedCard(newSelectedCard);
              params.set('selectedCard', newSelectedCard);
              if (cardModal) {
                cardModal.scrollTo({ top: 0, behavior: 'smooth' });
              }
            } else if (currentPage < totalPages) {
              params.set('page', currentPage + 1);
            }
          }

          navigate({ search: params.toString() }, { replace: true });
        }
      } else {
        if (swipeDistance >= swipeThreshold) {
          if (eventData.dir === 'Right') {
            setShowSidebar(true);
          } else if (eventData.dir === 'Left') {
            setShowSidebar(false);
          }
        }
      }
    },
    trackMouse: false,
    preventDefaultTouchmoveEvent: true,
  });

  useEffect(() => {
    // const token = localStorage.getItem('token');

    // Attempt to retrieve the token from localStorage
    let token = null;

    // If the token does not exist, check for 'hcardss' in cookies
    if (!token) {
      const cookies = document.cookie.split('; ');
      const hcardssCookie = cookies.find(cookie => cookie.startsWith('hcardss='));
      //console.log(cookies);
      if (hcardssCookie) {
        token = hcardssCookie.split('=')[1]; // Extract the token value from 'hcardss' cookie
      }
    }

    // Function to delete the 'hcardss' cookie
    const deleteCookie = (name) => {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
    };

    if (token) {
      axios.post('/api/auth/auth.php', { action: 'check', token: token })
        .then(response => {
          const hc = response.data.hc;
          //console.log(hc);
          if (hc.loggedin) {
            setUser({
              userid: hc.userid,
              username: hc.username,
              rank: hc.rank,
              mod: hc.mod,
              profile_picture: hc.picture,
              supIcon: hc.supIcon,
              supColor: hc.supColor

            });
          } else {
            localStorage.removeItem('token');
            deleteCookie('hcardss');
          }
        })
        .catch(() => {
          localStorage.removeItem('token');
          deleteCookie('hcardss');
        });
    }
  }, []);

  const handleLogin = (user) => {
    setUser(user);
  };

  const handleLogout = async () => {
    // Function to delete the 'hcardss' cookie
    const deleteCookie = (name) => {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
    };

    try {
      await axios.post('/api/auth/auth.php', {
        action: 'logout',
      });

      localStorage.removeItem('token');
      deleteCookie('hcardss');
      setUser(null);
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  // useEffect(() => {
  //   const fetchData = async (cancelToken) => {
  //     setIsLoading(1);
  //     try {
  //       const response = await axios.get(`https://www.hearthcards.net/contest/json_custom_react.php`, {
  //         params: {
  //           search: filters.search,
  //           page: currentPage,
  //           class: filters.class,
  //           mana: filters.cost,
  //           deckid: filters.category,
  //           startDate: filters.startDate,
  //           endDate: filters.endDate,
  //           cardtype: filters.cardtype,
  // 		language: settings.language,
  //         },
  //         cancelToken: cancelToken.token,
  //       });
  //       setCards(response.data.cards);
  //       setTotalPages(response.data.main.maxpage); // Assuming your API returns the total number of pages
  //       setIsLoading(0);
  //     } catch (error) {
  //       if (axios.isCancel(error)) {
  //         console.log('Request canceled', error.message);
  //       } else {
  //         // handle error
  //       }
  //     }
  //   };

  //   // Create a new cancel token for the current request
  //   const cancelTokenSource = axios.CancelToken.source();

  //   // Update URL with filters
  //   const params = new URLSearchParams();
  //   Object.entries(filters).forEach(([key, value]) => {
  //     if (value) {
  //       params.set(key, value);
  //     }
  //   });
  //   if (currentPage > 1) {
  //     params.set('page', currentPage);
  //   }

  //   navigate({ search: params.toString() }, { replace: true });

  //   fetchData(cancelTokenSource);

  //   // Cancel the request if the effect is cleaned up
  //   return () => cancelTokenSource.cancel('Operation canceled due to new request.');
  // }, [filters, currentPage, navigate, settings.language]);



  // useEffect(() => {
  //   const params = new URLSearchParams();
  //   Object.entries(filters).forEach(([key, value]) => {
  //     if (value) {
  //       params.set(key, value);
  //     }
  //   });
  //   if (currentPage > 1) {
  //     params.set('page', currentPage);
  //   }
  //   if (selectedCard) {
  //     params.set('selectedCard', selectedCard);
  //   } else {
  //     params.delete('selectedCard');
  //   }
  // if (selectedUser) {
  //   params.set('selectedUser', selectedUser);
  // } else {
  //   params.delete('selectedUser');
  // }
  //   navigate({ search: params.toString() }, { replace: true });
  // }, [selectedCard, selectedUser]);

  const handleCardClick = (card) => {
    setSelectedCard(card.id);
  };

  const handleCloseModal = () => {
    setSelectedCard(null);

    params.delete('selectedCard');
    //console.log(params);
    navigate({ search: params.toString() }, { replace: true });
    document.body.classList.remove('no-scroll');
  };

  useEffect(() => {
    if (params.get('selectedCard')) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
  }, [params.get('selectedCard')]);

  const handleSettingsOpen = () => {
    setShowSettings(true);
  };

  const handleSettingsClose = () => {
    setShowSettings(false);
  };

  const handleSettingsSave = (newSettings) => {
    //console.log(newSettings);
    setSettings(newSettings);
    setShowSettings(false);
  };

  //   const handleBackFromUserProfile = () => {
  //   setSelectedUser(null);
  // };

  if (showLoginForm) {
    return (<LoginForm onClose={() => setShowLoginForm(false)} />)
  }
  //{!user && <Login setUser={handleLogin} />}
  return (
    <>
      <ModeratorActionProvider>
        <div {...swipeHandlers}>
          <Navbar bg="light" className="sticky-top">
            <Container fluid>
              <Button variant="link" className="me-2 d-sm-none" onClick={handleToggleSidebar} style={{ paddingLeft: '0.3rem', paddingRight: '0.3rem' }}>
                <FaBars style={{ color: 'rgb(222, 167, 0)', fontSize: '1.5rem', verticalAlign: '-.4rem' }} />
              </Button>
              <Navbar.Brand href="/">
                <img
                  src="/gallery/images/hearthcards-logo.webp"
                  width="30"
                  height="30"
                  className="d-inline-block align-top"
                  alt="HearthCards Logo"
                />

              </Navbar.Brand>
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <Navbar.Collapse id="basic-navbar-nav">
                <Form className="mx-auto d-flex">
                  <FormControl
                    type="search"
                    placeholder="Search"
                    className="navbar-search-input me-2"
                    aria-label="Search"
                    onChange={(e) => {
                      if (e.target.value === '') {
                        // Handle case when input is emptied
                        setSearchParams(prevParams => {
                          prevParams.delete('category');
                          prevParams.delete('page');
                          prevParams.delete('search');
                          return prevParams;
                        });
                      }
                    }}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault(); // Prevent the form from submitting
                        // Trigger your search function here, using the current value in the input
                        setSearchParams(prevParams => {
                          prevParams.delete('category');
                          prevParams.delete('page');
                          prevParams.set('search', e.target.value);
                          return prevParams;
                        });
                      }
                    }}

                  />
                </Form>


                <Nav>

                  {user ? (
                    <>
                      <NavDropdown align="end"
                        title={
                          <div className="pull-left">
                            {user.username}
                            <div className="position-relative d-inline-block">
                              <img
                                className="navbar-userpic rounded-circle ms-2"
                                // src={user?.profile_picture ? `/images/users/pictures/${user.profile_picture}` : "/gallery/images/profile-image.jpg"}
                                src={
                                  user?.profile_picture
                                    ? (user.profile_picture.includes('http')
                                      ? user.profile_picture
                                      : `/images/users/pictures/${user.profile_picture}`)
                                    : "/gallery/images/profile-image.jpg"
                                }
                                alt="user pic"
                                style={{ width: "30px", height: "30px", objectFit: "cover" }}
                              />
                              {unreadNotifications > 0 && (
                                <span className="position-absolute top-0 end-0 translate-end p-1 bg-danger border border-light rounded-circle">
                                  <span className="visually-hidden">New notifications</span>
                                </span>
                              )}
                            </div>
                          </div>
                        } id="basic-nav-dropdown">
                        <NavDropdown.Item as={Link} to={`/user/${user.userid}`}>Profile</NavDropdown.Item>
                        <NavDropdown.Item as={Link} to="/notifications"> {unreadNotifications > 0 && (<FaBell />)} Notifications </NavDropdown.Item>
                        <NavDropdown.Item onClick={handleSettingsOpen}>Settings</NavDropdown.Item>
                        <NavDropdown.Item onClick={() => setShowSupportWebsite(true)}>Donate</NavDropdown.Item>

                        {user?.mod && (
                          <>
                            <NavDropdown.Divider />
                            <NavDropdown.Item as={Link} to="/reports">
                              <FaShieldAlt /> Reports
                            </NavDropdown.Item>
                            <NavDropdown.Item as={Link} to="/moderation">
                              <FaShieldAlt /> Mod Log
                            </NavDropdown.Item>
                            <NavDropdown.Divider />
                          </>
                        )}


                        <NavDropdown.Item onClick={handleLogout}>Logout</NavDropdown.Item>
                      </NavDropdown>
                    </>
                  ) : (
                    <NavDropdown align="end"
                      title={
                        <div className="pull-left">
                          Sign In
                          <img className="navbar-userpic rounded-circle ms-2"
                            src="/gallery/images/profile-image.jpg"
                            alt="user pic"
                            style={{ width: "30px", height: "30px", objectFit: "cover" }}
                          />
                        </div>
                      } id="basic-nav-dropdown">
                      <NavDropdown.Item onClick={handleSettingsOpen}>Settings</NavDropdown.Item>
                      <NavDropdown.Item onClick={() => setShowSupportWebsite(true)}>Donate</NavDropdown.Item>
                      <NavDropdown.Divider />
                      <NavDropdown.Item onClick={() => setShowLoginForm(true)}>Login</NavDropdown.Item>
                    </NavDropdown>

                  )}
                </Nav>
              </Navbar.Collapse>
            </Container>
          </Navbar>


          {/* Mobile Sidebar */}
          <Offcanvas show={showSidebar} onHide={handleToggleSidebar} placement="start" responsive="lg" className="d-lg-none offcanvas-filters" style={{ maxWidth: '80%' }}>
            <div className="hc-panel-right-bottom"></div>
            {/* <Offcanvas.Header closeButton>
              <Offcanvas.Title>Filters and Categories</Offcanvas.Title>
            </Offcanvas.Header> */}
            <Offcanvas.Body>
              <button type="button" className="btn-close position-absolute top-0 end-0 m-3" aria-label="Close" onClick={handleToggleSidebar}></button>
              <div className="hc-panel-right-content-mobile mb-5">
                <Categories filters={filters} setFilters={setFilters} setCurrentPage={setCurrentPage} onCategoryClick={() => { window.scrollTo(0, 0); setShowSidebar(false) }} />

                <div className="mt-2 mb-3">
                  {/* <button type="button" className="btn btn-outline-success w-100" onClick={() => { setShowSidebar(false); setSelectedCard(10451208); } }>Friendly Chat</button>
                  <button type="button" className="btn btn-outline-success w-100 mt-1" onClick={() => { setShowSidebar(false); setSelectedCard('0'); } }>Bugs & Suggestions</button>
                  <button type="button" className="btn btn-outline-success w-100 mt-1" onClick={() => { setShowSidebar(false); setSelectedCard('13312404'); } }>Gallery Rules</button> */}

                    <ContestButton
                      settings={settings}
                      contestId="2"
                      contestName="[REDACTED]"
                      contestImage="https://www.hearthcards.net/images/contest/sketch/2.svg"
                      backgroundImage="https://www.hearthcards.net/images/Hearthstone_Tavern_Brawl_Key_Art.webp"
                    />

                  <Link onClick={() => { setShowSidebar(false); }} to={buildUrlWithParams({ ...Object.fromEntries(new URLSearchParams(window.location.search)), selectedCard: 13919738 })} className="btn btn-outline-success w-100 filter pinned-news"><FaNewspaper /> News</Link>
                  <Link onClick={() => { setShowSidebar(false); }} to={buildUrlWithParams({ ...Object.fromEntries(new URLSearchParams(window.location.search)), selectedCard: 13312404 })} className="btn btn-outline-success w-100 mt-1 filter pinned-rules"><FaDiaspora /> Gallery Rules</Link>
                  {settings && settings.language && settings.language == 'ru' ? (
                    <Link onClick={() => { setShowSidebar(false); }} to={buildUrlWithParams({ ...Object.fromEntries(new URLSearchParams(window.location.search)), selectedCard: 11965320 })} className="btn btn-outline-success w-100 mt-1 filter pinned-chat"><IoMdChatboxes /> Дружеский Чат</Link>
                  ) : (
                    <Link onClick={() => { setShowSidebar(false); }} to={buildUrlWithParams({ ...Object.fromEntries(new URLSearchParams(window.location.search)), selectedCard: 10451208 })} className="btn btn-outline-success w-100 mt-1 filter pinned-chat"><IoMdChatboxes /> Friendly Chat</Link>
                  )
                  }
                  <Link onClick={() => { setShowSidebar(false); }} to={buildUrlWithParams({ ...Object.fromEntries(new URLSearchParams(window.location.search)), selectedCard: 0 })} className="btn btn-outline-success w-100 mt-1 filter pinned-bugs"><FaBug /> Bugs & Suggestions</Link>
                  <Link onClick={() => { setShowSidebar(false); }} to={buildUrlWithParams({ ...Object.fromEntries(new URLSearchParams(window.location.search)), selectedCard: 14316205 })} className="btn btn-outline-success w-100 mt-1 filter pinned-contest-ideas"><FaLightbulb /> Contest Ideas</Link>



                </div>

                <Filters filters={filters} setFilters={setFilters} setCurrentPage={setCurrentPage} />
              </div>
            </Offcanvas.Body>
          </Offcanvas>


          <div className="App container mt-1">

            <div className="row">
              <div className="hc-panel-left col-md-9 order-md-1 order-2 position-relative">
                <div className="hc-panel-left-bottom"></div>
                <div className="hc-panel-left-content">
                  <Outlet context={[cards, setCards, currentPage, setCurrentPage, totalPages, setTotalPages]} />


                  {/* 
		 {selectedUser ? (
            <UserProfile userId={selectedUser} onBack={handleBackFromUserProfile} selectedCard={ returnedValue  => setSelectedCard(returnedValue) } />
          ) : showNotifications ? (
              <><NotificationsPage onCardClick={ (e) => setSelectedCard(e) } onClose={handleCloseNotifications} /></>
            ) : (
		  <>
          <ActiveFilters filters={filters} handleRemoveFilter={(filterName) => {
            setFilters({ ...filters, [filterName]: '' });
            setCurrentPage(1);
          }} />
          <div style={{ opacity: isLoading ? '0.8' : '1' }}>
            <CardList cards={cards} loading={isLoading} onCardClick={handleCardClick} settings={settings} />
          </div>
          <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={setCurrentPage} />
		  </>
          )} */}




                </div>
              </div>
              <div className="hc-panel-right col-md-3 order-md-2 order-1 d-none d-sm-block position-relative">
                <div className="hc-panel-right-bottom"></div>
                <div className="hc-panel-right-content form-group pt-3">
                  {/* <label>Category:</label> */}
                  <div className="mt-2"><Categories filters={filters} setFilters={setFilters} setCurrentPage={setCurrentPage} onCategoryClick={() => { }} /></div>
                  <label>Pinned:</label>
                  <div>

                    <ContestButton
                      settings={settings}
                      contestId="2"
                      contestName="[REDACTED]"
                      contestImage="https://www.hearthcards.net/images/contest/sketch/2.svg"
                      backgroundImage="https://www.hearthcards.net/images/Hearthstone_Tavern_Brawl_Key_Art.webp"
                    />



                    <Link onClick={() => { setShowSidebar(false); }} to={buildUrlWithParams({ ...Object.fromEntries(new URLSearchParams(window.location.search)), selectedCard: 13919738 })} className="btn btn-outline-success w-100 filter pinned-news"><FaNewspaper /> News</Link>
                    <Link onClick={() => { setShowSidebar(false); }} to={buildUrlWithParams({ ...Object.fromEntries(new URLSearchParams(window.location.search)), selectedCard: 13312404 })} className="btn btn-outline-success w-100 mt-1 filter pinned-rules"><FaDiaspora /> Gallery Rules</Link>
                    {settings && settings.language && settings.language == 'ru' ? (
                      <Link onClick={() => { setShowSidebar(false); }} to={buildUrlWithParams({ ...Object.fromEntries(new URLSearchParams(window.location.search)), selectedCard: 11965320 })} className="btn btn-outline-success w-100 mt-1 filter pinned-chat"><IoMdChatboxes /> Дружеский Чат</Link>
                    ) : (
                      <Link onClick={() => { setShowSidebar(false); }} to={buildUrlWithParams({ ...Object.fromEntries(new URLSearchParams(window.location.search)), selectedCard: 10451208 })} className="btn btn-outline-success w-100 mt-1 filter pinned-chat"><IoMdChatboxes /> Friendly Chat</Link>
                    )
                    }
                    <Link onClick={() => { setShowSidebar(false); }} to={buildUrlWithParams({ ...Object.fromEntries(new URLSearchParams(window.location.search)), selectedCard: 0 })} className="btn btn-outline-success w-100 mt-1 filter pinned-bugs"><FaBug /> Bugs & Suggestions</Link>
                    <Link onClick={() => { setShowSidebar(false); }} to={buildUrlWithParams({ ...Object.fromEntries(new URLSearchParams(window.location.search)), selectedCard: 14316205 })} className="btn btn-outline-success w-100 mt-1 filter pinned-contest-ideas"><FaLightbulb /> Contest Ideas</Link>

                    {/* <button type="button" className="btn btn-outline-success w-100" onClick={() => setSelectedCard('13919738')}>News</button>
            <button type="button" className="btn btn-outline-success w-100 mt-1" onClick={() => setSelectedCard('13312404')}>Gallery Rules</button>
              <button type="button" className="btn btn-outline-success w-100 mt-1" onClick={() => setSelectedCard(10451208)}>Friendly Chat</button>
              <button type="button" className="btn btn-outline-success w-100 mt-1" onClick={() => setSelectedCard('0')}>Bugs & Suggestions</button> */}
                  </div>

                  <Filters filters={filters} setFilters={setFilters} setCurrentPage={setCurrentPage} />
                </div>
              </div>
            </div>



            {selectedCard && <CardModal card={selectedCard} setCards={setCards} user={user} onClose={handleCloseModal} />}
            {showSettings && <SettingsModal onClose={handleSettingsClose} onSave={handleSettingsSave} show={showSettings} />}
            {showSupportWebsite && <SupportWebsiteModal onClose={() => setShowSupportWebsite(false)} onSave={handleSettingsSave} show={showSupportWebsite} />}
          </div>
        </div>
        <CustomScrollRestoration />
      </ModeratorActionProvider>
    </>
  );
}


export default App;
